import { useEffect, useState } from "react";

/**
 * 保留最近一次非空值，供弹层退场动画继续渲染。
 * 状态更新放到异步任务中，避免在 render 或 effect 主体里同步触发级联渲染。
 */
export function useLastPresentValue(value) {
  const [lastValue, setLastValue] = useState(value);

  useEffect(() => {
    if (value == null) return undefined;
    const timer = window.setTimeout(() => {
      setLastValue((current) => (current === value ? current : value));
    }, 0);
    return () => window.clearTimeout(timer);
  }, [value]);

  return value ?? lastValue;
}

export default useLastPresentValue;
